import { render, staticRenderFns } from "./Product_amh_mp4.vue?vue&type=template&id=5c7ebb0c&scoped=true&"
import script from "./Product_amh_mp4.vue?vue&type=script&lang=js&"
export * from "./Product_amh_mp4.vue?vue&type=script&lang=js&"
import style0 from "./Product_amh_mp4.vue?vue&type=style&index=0&id=5c7ebb0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ebb0c",
  null
  
)

export default component.exports